import React, { PropsWithChildren } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { useToolbarHeight } from '../ui';
import Navbar from './Navbar';
import { Sidebar } from './Sidebar';

const PrivateLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const toolbarHeight = useToolbarHeight();
  const minHeight = `calc(100vh - ${toolbarHeight}px)`;

  return (
    <>
      <Navbar />
      <Box
        display="flex"
        sx={{ minHeight, background: theme.palette.common.white }}
      >
        {isDesktop ? (
          <Box
            sx={{
              borderRight: `1px solid ${theme.palette.divider}`,
              backgroundColor: theme.palette.common.white,
            }}
          >
            <Sidebar />
          </Box>
        ) : null}
        <Box
          flexGrow={1}
          sx={{ background: '#E5EDFE', minWidth: 0 }}
          display="flex"
          flexDirection="column"
        >
          {children}
        </Box>
      </Box>
    </>
  );
};

export default PrivateLayout;
